import React from 'react';
import { styled } from '@mui/material/styles';
import { Controller, useFormContext } from 'react-hook-form';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { Stack } from '@mui/material';
import { fr } from 'date-fns/locale/fr';
import { DatePicker as MuiDatepicker } from '@mui/x-date-pickers/DatePicker';

export const DatePicker = styled(MuiDatepicker)<{ styles?: React.CSSProperties }>(({ theme, styles }) => ({
    '& .MuiOutlinedInput-root': {
        padding: '14px 16px',
        borderRadius: '8px',
        fontSize: 14,
        border: `1px solid ${theme.palette?.primaryWhitePurple.main}`,

        '& fieldset': {
            borderWidth: 1,
        },
        '&:hover fieldset': {
            borderWidth: 1,
        },
        '&.Mui-focused fieldset': {
            borderWidth: 1,
        },
    },
    ...styles,
}));

interface InputDateProps {
    name: string;
    id?: string;
    styles?: React.CSSProperties;
}

const InputDate: React.FC<InputDateProps> = ({ name, styles }) => {
    const { control } = useFormContext();

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
            <Stack spacing={1} direction="column">
                <Controller
                    name={`${name}`}
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            {...field}
                            slots={{
                                openPickerIcon: () => <i className="fi fi-br-calendar" style={{ fontSize: 16 }} />,
                            }}
                            value={field.value || null}
                            onChange={date => field.onChange(date)}
                            slotProps={{
                                textField: {
                                    size: 'small',
                                    placeholder: 'JJ/MM/AAAA',
                                },
                            }}
                            styles={styles}
                        />
                    )}
                />
            </Stack>
        </LocalizationProvider>
    );
};

export default InputDate;
